import React from 'react';
import PropTypes from 'prop-types';
import SMReservationHelper from 'components/helpers/SMReservationHelper';

class SMReservationEditViewPlans extends React.Component{

  radioButtonDidChangeValue(e) {
    this.props.delegate.changePlan(e.currentTarget.value);
  }

  renderBasePriceText(plan) {
    let text = [];
    if (plan.has_session_price) {
      return plan.session_price_text+' / '+plan.session_price_unit_text;
    } else {
      if (plan.has_hourly_price) {
        text.push(plan.hourly_price_text+' / '+plan.hourly_price_unit_text);
      }
      if (plan.has_daily_price) {
        text.push(plan.daily_price_text+' / '+plan.daily_price_unit_text);
      }
      if (plan.has_stay_price) {
        text.push(plan.stay_price_text+' / '+plan.stay_price_unit_text);
      }
    }

    if (text.length == 1) {
      return text[0];
    } else {
      return(
        <span>
          <span className='mr20'>{text[0]}</span>{text[1]}
          </span>
      );
    }
  }

  render() {
    let plans = [];
    let room = this.props.room;
    let registeredPlans = this.props.plans;
    let lengthPlans = registeredPlans ? registeredPlans.length : 0;
    let reservation = this.props.reservation;

    let basicPlanSelected = reservation.plan_id == undefined || reservation.plan_id == 0 || registeredPlans.length == 0;

    for (let i=0; i < lengthPlans; i++) {
      let item = registeredPlans[i];
      let checked = reservation.plan_id == item.id;

      plans.push([
        <input
          type="radio"
          key={item.id+'-radio'}
          value={item.id}
          id={'plan-'+item.id}
          name="plan_id"
          checked={checked}
          onChange={this.radioButtonDidChangeValue.bind(this)}
          disabled={!SMReservationHelper.isDetailEditable(reservation)} />,

        <label
          htmlFor={'plan-'+item.id}
          key={item.id+'-label'}
          className="form-radio w200">
          {item.name}
        </label>,
        this.renderBasePriceText(item),
        <p
          key={item.id+'-p'}
          className={"dashboard-title__supplement mt10 " + (i < lengthPlans - 1 ? "mb30" : '')}>
          {item.description}
        </p>
      ]);
    }

    return(
      <td>
        <input
          type="radio"
          value='0'
          id='plan-0'
          name='plan_id'
          checked={basicPlanSelected}
          onChange={this.radioButtonDidChangeValue.bind(this)}
          disabled={!SMReservationHelper.isDetailEditable(reservation)} />

        <label
          htmlFor='plan-0'
          className={"form-radio w200"}>
          {room.plan_name}
        </label>
        {this.renderBasePriceText(room)}
        <p
          className={"dashboard-title__supplement mt10 " + (lengthPlans > 0 ? "mb30" : '')}>{room.plan_description}
        </p>
        {plans}
      </td>
    );
  }
}

SMReservationEditViewPlans.propTypes = {
  reservation: PropTypes.shape().isRequired,
  room: PropTypes.shape().isRequired,
  plans: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  delegate: PropTypes.shape()
};
export default SMReservationEditViewPlans;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewPlans.jsx